import { FC, Fragment } from 'react'
import { TextInput, required } from 'react-admin'

export const CertificatesCreateContact: FC = () => (
  <Fragment>
    <TextInput source="contactNaam" label="data.contactpersoon" validate={[required()]} fullWidth />
    <TextInput source="contactEmail" type="email" label="data.email" validate={[required()]} fullWidth />
    <TextInput source="contactTelefoon" label="data.phone" validate={[required()]} fullWidth />
  </Fragment>
)